/**
 * Cart Drawer Enhanced — Mittai Shop
 * Handles cross-sell "ADD" button functionality with event delegation.
 * Event delegation on <cart-drawer> ensures buttons survive AJAX re-renders.
 */

(function() {
  'use strict';

  const cartDrawerEl = document.querySelector('cart-drawer');
  if (!cartDrawerEl) return;

  // Cross-sell ADD button handler (event delegation)
  cartDrawerEl.addEventListener('click', function(e) {
    const addBtn = e.target.closest('.cart-drawer__cross-sell-add');
    if (!addBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    // Show loading state
    const originalText = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    // Build sections for re-render (match CartDrawer.getSectionsToRender pattern)
    const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];

    const body = JSON.stringify({
      items: [{ id: parseInt(variantId), quantity: 1 }],
      sections: sectionsToRender,
      sections_url: window.location.pathname
    });

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(response) {
      if (response.status) {
        // Error (e.g., variant not available)
        addBtn.disabled = false;
        addBtn.textContent = originalText;
        console.warn('Add to cart error:', response.description);
        return;
      }
      // Success — re-render the cart drawer using the existing renderContents method
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(response);
      }
    })
    .catch(function(error) {
      console.error('Add to cart failed:', error);
      addBtn.disabled = false;
      addBtn.textContent = originalText;
    });
  });
})();
